function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _get from 'lodash/get';
import set from 'lodash/set';
import has from 'lodash/has';
import each from 'lodash/each';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import { createStore } from 'redux';
var SET = 'SET';
var REMOVE = 'REMOVE';

function contextReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      path = action.path,
      payload = action.payload;

  switch (type) {
    case SET:
      {
        var ctx = path.length ? "".concat(path.join('.'), ".") : '';
        each(payload, function (value, key) {
          return set(state, "".concat(ctx).concat(key), value);
        });
        return state;
      }

    case REMOVE:
      {
        var data = path.length ? _get(state, path.join('.')) : state;
        each(payload, function (key) {
          if (has(data, key)) delete data[key];
        });
        return state;
      }

    default:
      return state;
  }
} // internal redux-based implementation of an observable object store


export default function createReduxContextStore(_ref) {
  var preloadData = _ref.preloadData;
  var reduxStore = createStore(contextReducer, preloadData);
  return {
    subscribe: reduxStore.subscribe,
    get: function get(key, path) {
      var state = reduxStore.getState();
      var data = path.length ? _get(state, path.join('.'), {}) : state;
      if (key) return _get(data, key);
      return data;
    },
    set: function set(key, value) {
      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (!key) return reduxStore.dispatch({
        type: SET,
        payload: value,
        path: path
      });
      if (isPlainObject(key)) return reduxStore.dispatch({
        type: SET,
        payload: key,
        path: path
      }); // eslint-disable-line prettier/prettier

      return reduxStore.dispatch({
        type: SET,
        payload: _defineProperty({}, key, value),
        path: path
      }); // eslint-disable-line prettier/prettier
    },
    remove: function remove(keys) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var payload = isArray(keys) ? keys : [keys];
      return reduxStore.dispatch({
        type: REMOVE,
        payload: payload,
        path: path
      });
    }
  };
}